var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireAlarmSounder01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 1.37,
    className: "st2",
    width: 0.5,
    height: 12.71
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.27,14.08c-0.07,0-0.14,0-0.2,0l0.02-0.5c2.87,0.09,5.28-2.08,5.46-4.96c0.04-0.24,0.06-0.45,0.08-0.67 c0.09-1.54-0.42-3.03-1.44-4.19S9.74,1.92,8.2,1.83l0.03-0.5c1.68,0.1,3.21,0.85,4.33,2.11c1.11,1.26,1.67,2.87,1.57,4.55 c-0.01,0.23-0.04,0.46-0.08,0.69C13.85,11.74,11.33,14.08,8.27,14.08z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.07,6.03 2.84,6.03 2.84,2.25 3.34,2.25 3.34,5.53 8.07,5.53  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3.34,13.83 2.84,13.83 2.84,10.05 8.07,10.05 8.07,10.55 3.34,10.55  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireAlarmSounder01);
export default __webpack_public_path__ + "static/media/FireAlarmSounder-01.75f0a795fd91f7870eb678f58f442265.svg";
export { ForwardRef as ReactComponent };